import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "kpi-neon-card pa-3 d-flex flex-column justify-space-between w-100" }
const _hoisted_3 = { class: "d-flex justify-space-between align-center mb-2" }
const _hoisted_4 = { class: "d-flex align-center ga-2 w-100" }
const _hoisted_5 = { class: "status-neon-box ok-glow flex-grow-1 pa-2 text-center" }
const _hoisted_6 = { class: "status-value text-success mt-1" }
const _hoisted_7 = { class: "status-neon-box alert-glow flex-grow-1 pa-2 text-center" }
const _hoisted_8 = { class: "status-value text-warning mt-1" }
const _hoisted_9 = { class: "status-neon-box alarm-glow flex-grow-1 pa-2 text-center" }
const _hoisted_10 = { class: "status-value text-error mt-1" }
const _hoisted_11 = { class: "status-neon-box down-glow flex-grow-1 pa-2 text-center" }
const _hoisted_12 = { class: "status-value text-grey-lighten-1 mt-1" }

import { computed } from 'vue';

interface StatusCounts {
    distri?: { ok: number; alarm: number; alert: number; down: number };
    acceso?: { ok: number; alarm: number; alert: number; down: number };
    client?: { ok: number; alarm: number; alert: number; down: number };
}

interface Props {
    statusCounts?: StatusCounts;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StatusSummaryBottomView',
  props: {
    statusCounts: { default: () => ({
        client: { ok: 0, alarm: 0, alert: 0, down: 0 }
    }) }
  },
  setup(__props: any) {

const props = __props;

const clientData = computed(() => props.statusCounts?.client || { ok: 0, alarm: 0, alert: 0, down: 0 });

const clientTotal = computed(() => {
    const d = clientData.value;
    return (d.ok || 0) + (d.alarm || 0) + (d.alert || 0) + (d.down || 0);
});

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "category-title text-truncate font-weight-black text-grey-lighten-2" }, " Clientes ", -1)),
        _createVNode(_component_v_chip, {
          size: "x-small",
          color: "cyan",
          variant: "tonal",
          class: "font-weight-black px-2",
          style: {"height":"18px","font-size":"0.60rem"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(" TOTAL: " + _toDisplayString(clientTotal.value), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_icon, {
            color: "#00E676",
            style: {"font-size":"13px"}
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("mdi-check-circle-outline", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_6, _toDisplayString(clientData.value.ok), 1),
          _cache[2] || (_cache[2] = _createElementVNode("div", {
            class: "status-label text-truncate",
            title: "En Línea"
          }, "En Línea", -1))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_v_icon, {
            color: "#FFEA00",
            style: {"font-size":"13px"}
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-alert-circle-outline", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_8, _toDisplayString(clientData.value.alert), 1),
          _cache[4] || (_cache[4] = _createElementVNode("div", {
            class: "status-label text-truncate",
            title: "Alerta Leve"
          }, "Alerta", -1))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_icon, {
            color: "#FF3D00",
            style: {"font-size":"13px"}
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("mdi-alert-octagon-outline", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_10, _toDisplayString(clientData.value.alarm), 1),
          _cache[6] || (_cache[6] = _createElementVNode("div", {
            class: "status-label text-truncate",
            title: "Alarma Crítica"
          }, "Alarma", -1))
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_v_icon, {
            color: "#9E9E9E",
            style: {"font-size":"13px"}
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("mdi-close-circle-outline", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_12, _toDisplayString(clientData.value.down), 1),
          _cache[8] || (_cache[8] = _createElementVNode("div", {
            class: "status-label text-truncate",
            title: "Sin Servicio"
          }, "Sin Serv.", -1))
        ])
      ])
    ])
  ]))
}
}

})